import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar";
import ZOOM_WEB_MATRIX from "resources/img/zoom_compat_matrix.jpg";

export default React.createClass({
  displayName: "faq",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [];

    var scrollToElement = initDeepLinkData(this.props);

    return {
            data,
            navMenuParent: null,
            navMenu: null,
            scrollToElement: scrollToElement

          };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container faq">
            <section id="Frequently Asked Questions">
              <div className="title">
                <Glyphicon glyph="comment" />
                <h2 id="troubleshooting">Troubleshooting</h2>
              </div>
              <p>Here are some common development/integration questions we get and some helpers and/or next steps if you are encountering issues.</p>
              <hr />
            </section>

            <section>

              <h4 id="server-init-network">During Server SDK initialization, I am getting a message that 'to be able to access https://api.zoomauth.com/ so that Key validation succeeds' — How do I resolve this issue?</h4>

              <p>The FaceTec Server SDKs must have access to the internet when using Development SDK Keys in order to validate the Key.  On a system with access to the public internet, initialization will succeed without issues.  You will receive a message like the above if the Device, Host Machine, or Docker Container are unable to access http://api.zoomauth.com/.</p>

              <p>In order to resolve this issue, you will need to figure out why your Server Instance and/or Docker Container do not have proper access to the internet (more specifically, FaceTec's API) in order for initialization to succeed.</p>

              <p>Machine configurations, network configurations, firewall rules, etc., can vary and FaceTec cannot provide a precise diagnosis about why your machine cannot access the internet.  However, we do have the following troubleshooting recommendations:</p>

              <ul>
                  <li><p>If you are on a Windows Host, please check your firewall settings and ensure you are allowing outbound network traffic to the internet (more specifically https://api.zoomauth.com).</p></li>
                  <li><p>If you are on Windows, please check your firewall settings and ensure you are allowing outbound network traffic to the internet (more specifically https://api.zoomauth.com).</p></li>
                  <li><p>Attempt to <code>curl google.com</code> to see if your Host Machine or Container have general access to the internet.</p></li>
                  <li><p>Attempt to <code>curl https://api.zoomauth.com/test-connection</code> to see if your Host Machine or Container have general access to FaceTec's API.</p></li>
                  <li><p>From the Linux Host and the FaceTec Container, use <code>ip link show</code> and <code>ip addr show</code> to diagnose if Docker is attaching a network interface to your Container.</p></li>
                  <li><p>From the Linux Host and the FaceTec Container, use <code>ip link show</code> and <code>ip addr show</code> to diagnose if Docker is attaching a network interface to your Container.</p></li>
                  <li><p>If you are using Docker, run <code>docker run -ti zoomrestsdk /bin/bash</code> to access a bash terminal from the FaceTec Container itself, then attempt to curl google and the FaceTec API per the above guidance to check if the Docker Container has proper access to the internet.</p></li>
             </ul>

             <hr />

              <h4 id="my-zoom-ux-customization-code-is-not-producing-the-desired-result">My FaceTec UX Customization code isn't producing the desired result.</h4>
              <p>We will be happy to assist you!  All you need to provide us with is a runnable sample app (including source code, not just an APK or IPA) that demonstrates your issue.  Please check out our guidance on <Link to="submitting-a-good-bug" target="_blank">Submitting a Good Bug</Link> and send this to us via the <Link to="support" target="_blank">Technical Support Form</Link>.</p>
              
              <hr />

              <h4 id="the-audit-trail-images-produced-by-zoom-cannot-generate-a-facemap">The Audit Trail Image(s) produced by FaceTec SDKs cannot generate a FaceMap.</h4>
              <p>The Audit Trail images are intended to be quality images from the user's User Session, sometimes user behavior can cause these images to be poor.  To overcome this, the default and recommended behavior is to get the user to try one more time.  Likely they will succeed and you will have a much higher quality Audit Trail Image.</p>

              <hr />

              <h4 id="the-audit-trail-images-produced-by-zoom-did-not-match-with-a-high-match-level-to-the-3d-facemap-from-the-same-session">The Audit Trail Image(s) produced by FaceTec did not match with a high Match Level to the 3D FaceMap from the same session.</h4>
              <p>The Audit Trail images are intended to be quality images from the user's User Session, sometimes user behavior can cause these images to be poor. This could also indicate that the user presented multiple faces to the camera during their session (either by accident, or this was a spoof attempt). The default and recommended behavior is to get the user to try again.  A real user will succeed and you will have a much higher quality Audit Trail Image.  If it is a spoof, it will continue to reject.</p>
            
              <hr />

              <h4 id="i-am-getting-an-error-when-submitting-to-the-ios-app-store">I am getting an error when submitting to the iOS App Store.</h4>
              <p>One common problem is missing the implementation step for adding a New Run Script to your Build Phases.  To resolve:  Go to Targets → Build Phases and add a New Run Script command (after Embed Frameworks phase).  The contents of this Run Script should have <code>bash {"${BUILT_PRODUCTS_DIR}/${FRAMEWORKS_FOLDER_PATH}/ZoomAuthentication.framework/strip-unused-architectures-from-target.sh"}</code></p>

              <p><strong>If the above appears to be configured correctly and in similar fashion to the iOS SDK Sample App, here are additional troubleshooting steps for iOS App Store submission issues:</strong></p>
              <ul>
                <li><p>Please look at the following video for the process (not shown in the video is selecting Product > Archive after showing initial settings) -- <a target="_blank" href="https://drive.google.com/file/d/1GMYgS31LiQb0IPMBWE1yzL2qkS6m_Tzm/view?usp=sharing">App Store Submission Process</a></p></li>
                <li><p>Please make sure your settings for embedding the framework and the Run Script to remove unused architectures is configured exactly as in the video.  Also please make sure you are using the same steps to submit to the App Store.  If anything is different, please let us know by providing a Screen Recording (Quicktime on Mac, Game Bar on Windows 10) of the exact configuration you have and the exact steps you are taking to submit to the App Store.</p></li>
                <li><p>Please note that the modifications we had to make on the sample app were to change the Bundle ID (we registered “com.facetec.ZoomAuthentication-Sample-App-testSubmission” as an App ID in our Apple Dev Account (https://developer.apple.com/account/resources/identifiers/list)), to update the version and build numbers to 2.0.1 to avoid Apple complaining about versions and Bundle IDs already being in use, and also to register a new App in App Store Connect (https://appstoreconnect.apple.com/apps) so that the Xcode process has a place to submit the Test App to.</p></li>
                <li><p>Please verify on your Dev Machine, that you are able to do the above steps in case there is an issue with the particular machine with creating App Store builds.</p></li>
              </ul>

              <p><strong>If you are still having issues, this is what we will need:</strong></p>
              <ul>
                <li><p>Please take a Screen Recording (Quicktime on Mac, Game Bar on Windows 10) of the entire process, showing the same parts that our video shows.</p></li>
                <li><p>Please double-confirm you are able to generate a valid App Store build using just our Sample App using steps similar to the above.</p></li>
                <li><p>In your own app can you show us exactly, with a screenshot showing everything about the configuration, how your Run Scripts is configured with the script to remove unused architectures.</p></li>
                <li><p>Last, please gather the distribution/code signing logs and send them to us.  <strong><Link to="/support">Getting the logs is imperative</Link> to us providing support.</strong></p></li>
              </ul>

              <hr />

              <h4 id="compiling-android-error-androidx">Compiling my Android App is erroring because it says the FaceTec SDK library uses AndroidX.</h4>
              <p>
                Regarding AndroidX, Android Support Libraries, and Jetifier, the FaceTec Android SDK utilizes AndroidX.  Depending on the current state of your app, this might cause compilation warnings or errors.  Our Customers and Partners who have come to us with these questions/issues all have found it very easy to use the tools and resources below to fix their apps.
              </p>

              <p>Google’s recommendation: <em>"We recommend using the AndroidX libraries in all new projects. You should also consider migrating existing projects to AndroidX as well."</em></p>

              <p>Google supports a tool to fix existing apps that are experiencing this issue — it is called Jetifier.  For more information:</p>

              <ul>
                <li><p><a href="https://developer.android.com/jetpack/androidx" target="_blank">AndroidX</a></p></li>
                <li><p><a href="https://developer.android.com/topic/libraries/support-library/index" target="_blank">Android Support Library</a></p></li>
                <li><p><a href="https://developer.android.com/studio/command-line/jetifier" target="_blank">Jetifier</a></p></li>
              </ul>
            </section>

            <SDKSidebar menuType="main" title="FAQ"/>

          </div>
        </div>
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/js/components/screens/troubleshooting.jsx